module.exports = __webpack_public_path__ + "img/comments.877f972e.svg";